module.exports = __webpack_public_path__ + "media/images/icon-store-search-active-93fef18e9f4ed0e6de08560190bd6723.svg";